export default "__VITE_ASSET__a6fpmSnK__"